var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#748DA9",
    d: "M14.005 3.833h2.5c.46 0 .834.373.834.834v10c0 .46-.373.833-.834.833h-15a.833.833 0 0 1-.833-.833V1.333c0-.46.373-.833.833-.833h12.5zM2.34 5.5v8.333h13.333V5.5zm0-3.333v1.666h10V2.167zm9.166 6.666h2.5V10.5h-2.5z"
  })));
};
export default SvgWallet;